const translations = {
  // Navbar
  'nav.home': 'Inicio',
  'nav.services': 'Servicios',
  'nav.track': 'Rastrear envío',
  'nav.about': 'Nosotros',
  'nav.contact': 'Contacto',
  'nav.trackNow': 'Rastrear ahora',

  // Footer
  'footer.tagline': 'Confiado por miles de empresas en todo el mundo para el seguimiento de envíos confiable y en tiempo real.',
  'footer.quickLinks': 'Enlaces rápidos',
  'footer.contactUs': 'Contáctenos',
  'footer.globalNumbers': 'Números globales',
  'footer.uk': 'Reino Unido',
  'footer.usa': 'Estados Unidos',
  'footer.canada': 'Canadá',
  'footer.allRightsReserved': 'Todos los derechos reservados.',
  'footer.privacy': 'Política de privacidad',
  'footer.terms': 'Términos de servicio',
  'footer.cookies': 'Política de cookies',

  // Hero
  'hero.badge': 'MÁS DE 50.000 EMPRESAS CONFÍAN EN NOSOTROS',
  'hero.headline1': 'Entregando el mundo,',
  'hero.headline2': 'A tiempo',
  'hero.subtext': 'Seguimiento de envíos en tiempo real por aire, tierra y mar. Sepa exactamente dónde está su carga — cada kilómetro del viaje.',
  'hero.placeholder': 'Ingrese número de seguimiento (ej. SWT-2024-001847)',
  'hero.trackBtn': 'Rastrear envío',
  'hero.tryLabel': 'Intente:',
  'hero.scroll': 'Desplázate para explorar',
  'hero.stat1': 'Paquetes entregados',
  'hero.stat2': 'Países atendidos',
  'hero.stat3': 'Tasa de puntualidad',
  'hero.stat4': 'Soporte 24/7',

  // Services Section
  'services.badge': 'Niveles de servicio',
  'services.title1': 'Elige tu',
  'services.title2': 'Plan de envío',
  'services.subtitle': 'Desde envíos económicos hasta servicio prioritario el mismo día — tenemos el servicio adecuado para cada envío.',
  'services.perShipment': 'Por envío',
  'services.monthlyPlan': 'Plan mensual',
  'services.monthlySaving': 'Los planes mensuales ahorran hasta un 35% frente a la tarifa por envío',
  'services.enterprise.title': '¿Necesita un plan empresarial personalizado?',
  'services.enterprise.desc': 'Descuentos por volumen, gestores de cuentas dedicados y SLA personalizados para remitentes de alta frecuencia.',
  'services.enterprise.cta': 'Contactar ventas',
  'services.perKg': 'por kg',
  'services.perMo': '/mes',
  'services.economy.name': 'Económico',
  'services.economy.tagline': 'Envío asequible',
  'services.economy.cta': 'Empiece gratis',
  'services.economy.time': '5–7 días hábiles',
  'services.standard.name': 'Estándar',
  'services.standard.tagline': 'Entrega diaria confiable',
  'services.standard.cta': 'Elegir Estándar',
  'services.standard.time': '2–3 días hábiles',
  'services.express.name': 'Express',
  'services.express.tagline': 'Entrega acelerada',
  'services.express.cta': 'Elegir Express',
  'services.express.time': 'Siguiente día hábil',
  'services.express.badge': 'Más popular',
  'services.priority.name': 'Prioritario',
  'services.priority.tagline': 'Servicio premium el mismo día',
  'services.priority.cta': 'Elegir Prioritario',
  'services.priority.time': 'Mismo día (ventana 2h)',
  'services.priority.badge': 'Premium',
  'services.feat.basicTracking': 'Seguimiento básico del paquete',
  'services.feat.emailNotif': 'Notificación de entrega por correo',
  'services.feat.20kg': 'Hasta 20 kg',
  'services.feat.insurance100': 'Seguro estándar ($100)',
  'services.feat.liveMap': 'Seguimiento en mapa en vivo',
  'services.feat.priority': 'Manejo prioritario',
  'services.feat.smsAlerts': 'Alertas SMS y push',
  'services.feat.signature': 'Firma en la entrega',
  'services.feat.fullTracking': 'Seguimiento completo en tiempo real',
  'services.feat.emailSms': 'Notificaciones correo + SMS',
  'services.feat.50kg': 'Hasta 50 kg',
  'services.feat.insurance500': 'Seguro estándar ($500)',
  'services.feat.dedicatedDriver': 'Conductor dedicado',
  'services.feat.emailSmsPush': 'Correo + SMS + alertas push',
  'services.feat.100kg': 'Hasta 100 kg',
  'services.feat.insurance2000': 'Seguro premium ($2.000)',
  'services.feat.routeOpt': 'Optimización de ruta',
  'services.feat.unlimitedWeight': 'Peso ilimitado',
  'services.feat.insurance10000': 'Seguro completo ($10.000)',
  'services.feat.dedicatedDriverAssigned': 'Conductor dedicado asignado',

  // Tracking Page
  'track.title': 'Rastrear su envío',
  'track.subtitle': 'Ingrese su número de seguimiento para ver el estado en tiempo real y las actualizaciones de entrega.',
  'track.placeholder': 'ej. SWT-2024-001847',
  'track.scanBtn': 'Escanear código',
  'track.trackBtn': 'Rastrear',
  'track.privacy': 'Su número de seguimiento es privado — solo usted puede ver los detalles de su envío',
  'track.enter.title': 'Ingrese su número de seguimiento',
  'track.enter.desc': 'Su número de seguimiento único fue enviado por correo al crear su envío. Se ve como',
  'track.feature1': 'Actualizaciones en tiempo real',
  'track.feature2': 'Seguimiento en mapa en vivo',
  'track.feature3': 'Alertas instantáneas',
  'track.notFound.title': 'Envío no encontrado',
  'track.notFound.desc': 'No encontramos un envío con el número de seguimiento',
  'track.notFound.hint': 'Por favor verifique el número o contacte a',
  'track.notFound.support': 'soporte',
  'track.found.title': 'Envío encontrado',
  'track.found.private': 'Privado para usted',
  'track.found.viewDetails': 'Ver detalles completos',
  'track.found.estDelivery': 'Entrega est.',
  'track.found.progress': 'Progreso',

  // About Page
  'about.badge': 'NUESTRA HISTORIA',
  'about.headline': 'Construido para el mundo moderno del comercio',
  'about.subtext': 'Fundada en 2014, SwiftTrack comenzó con una misión simple: hacer que el envío sea tan fácil como enviar un correo electrónico. Hoy, movemos millones de paquetes en más de 180 países.',
  'about.stat.founded': 'Año de fundación',
  'about.stat.countries': 'Países atendidos',
  'about.stat.deliveries': 'Entregas/año',
  'about.stat.partners': 'Socios comerciales',
  'about.mission.badge': 'NUESTRA MISIÓN',
  'about.mission.title1': 'Conectando personas,',
  'about.mission.title2': 'Entregando posibilidades',
  'about.mission.p1': 'Creemos que cada envío lleva más que bienes. Lleva confianza, relaciones y la promesa de algo mejor al otro lado. Nuestra plataforma tecnológica garantiza que cada paquete — desde un regalo de cumpleaños escrito a mano hasta un dispositivo médico que salva vidas — llegue exactamente cuando y donde debe.',
  'about.mission.p2': 'Combinamos seguimiento GPS de última generación, optimización de rutas con IA y una red de transportistas verificados para brindarle la experiencia de envío más confiable y transparente del mundo.',
  'about.values.title': 'Los valores que nos impulsan',
  'about.values.subtitle': 'Nuestra cultura se basa en cuatro pilares que guían cada decisión que tomamos.',
  'about.value1.title': 'Confiabilidad',
  'about.value1.desc': '99,7% de entregas a tiempo respaldadas por monitoreo en tiempo real y resolución proactiva de problemas.',
  'about.value2.title': 'Transparencia',
  'about.value2.desc': 'Visibilidad total en cada paso. Sin cargos ocultos, sin sorpresas — solo comunicación honesta y clara.',
  'about.value3.title': 'Sostenibilidad',
  'about.value3.desc': 'Flota de compensación de carbono y enrutamiento optimizado para minimizar nuestra huella ambiental.',
  'about.value4.title': 'Cliente primero',
  'about.value4.desc': 'Cada decisión que tomamos comienza con una pregunta: ¿cómo esto mejora las cosas para nuestros clientes?',
  'about.team.title1': 'Conoce nuestro',
  'about.team.title2': 'Liderazgo',
  'about.team.subtitle': 'Operadores y tecnólogos experimentados unidos por la pasión por la logística mundial.',

  // Contact Page
  'contact.title': 'Ponerse en contacto',
  'contact.subtitle': 'Preguntas, presupuestos o comentarios — nuestro equipo está listo para ayudar las 24 horas.',
  'contact.info.title': 'Estamos aquí para usted',
  'contact.info.desc': 'Comuníquese por cualquier canal. Tiempo de respuesta promedio inferior a 3 minutos para chat en vivo, inferior a 2 horas para correo electrónico.',
  'contact.info.address': 'Dirección',
  'contact.info.phone': 'Teléfono',
  'contact.info.email': 'Correo electrónico',
  'contact.info.hours': 'Horario de soporte',
  'contact.info.hoursVal': '24/7 — Nunca cerramos',
  'contact.form.title': 'Envíenos un mensaje',
  'contact.form.name': 'Nombre completo',
  'contact.form.email': 'Dirección de correo',
  'contact.form.phone': 'Teléfono',
  'contact.form.subject': 'Asunto',
  'contact.form.subjectPlaceholder': 'Seleccione un asunto',
  'contact.form.subjectTrack': 'Ayuda con seguimiento de envíos',
  'contact.form.subjectQuote': 'Solicitar presupuesto',
  'contact.form.subjectEnterprise': 'Soluciones empresariales',
  'contact.form.subjectBilling': 'Consulta de facturación',
  'contact.form.subjectOther': 'Otro',
  'contact.form.message': 'Mensaje',
  'contact.form.send': 'Enviar mensaje',
  'contact.form.sending': 'Enviando...',
  'contact.form.error': 'Algo salió mal. Por favor intente de nuevo.',
  'contact.sent.title': '¡Mensaje enviado!',
  'contact.sent.desc': 'Le responderemos en 2 horas.',
  'contact.sent.another': 'Enviar otro',
};

export default translations;
